module.exports = __webpack_public_path__ + "static/media/image10.9ceb376b.svg";